// Configuration for TMDB API
// All API calls are proxied through the backend — the API key stays server-side only.

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';

// Proxy helper: /tmdb?path=<tmdbPath>&<...params>
const tmdb = (tmdbPath, params = {}) => {
  const qs = new URLSearchParams({ path: tmdbPath, language: 'en-US', ...params }).toString();
  return `${BACKEND_URL}/tmdb?${qs}`;
};

export const SEARCH_BASE_URL   = (query) => tmdb('search/movie', { query });
export const POPULAR_BASE_URL  = tmdb('movie/popular');

// For login and voting (kept for compatibility — not actively used with email auth)
export const REQUEST_TOKEN_URL = tmdb('authentication/token/new');
export const LOGIN_URL         = tmdb('authentication/token/validate_with_login');
export const SESSION_ID_URL    = tmdb('authentication/session/new');

// Movie-detail helper: /tmdb?path=movie/{id}&append_to_response=credits
export const movieDetailUrl = (id) => tmdb(`movie/${id}`, { append_to_response: 'credits' });

// Image base URLs — these are public CDN URLs, no key needed
export const IMAGE_BASE_URL = 'https://image.tmdb.org/t/p/';
export const BACKDROP_SIZE  = 'w1280';
export const POSTER_SIZE    = 'w780';

// Legacy compat exports so existing imports don't break
export const API_URL = `${BACKEND_URL}/tmdb`;
export const API_KEY = '';  // key is server-side only

